import React, { useState, useEffect } from "react";
import ChatComponent from "../components/ChatComponent";
import ComapnyComponent from "../components/ComapnyComponent";
import ConsultComponent from "../components/ConsultComponent";
import ContactComponent from "../components/ContactComponent";
import FAQComponent from "../components/FAQComponent";
import FooterComponent from "../components/FooterComponent";
import FooterOneComponent from "../components/FooterOneComponent";
import HireusComponent from "../components/HireusComponent";
import PDComponent from "../components/P&DComponent";
import ProductShowcaseComponent from "../components/ProductShowcaseComponent";
import TechnologyComponent from "../components/TechnologyComponent";
import TestimonialComponent from "../components/TestimonialComponent";
import TopBgComponent from "../components/TopBgComponent";
import WWEComponent from "../components/WWEComponent";
import { motion } from "framer-motion";
import LoadingPage from "./LoadingPage";

function HomePage() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3800);
  });

  return loading ? (
    <LoadingPage />
  ) : (
    <>
      <motion.div exit={{ opacity: 0, backgroundColor: "#63FFCD" }}>
        <TopBgComponent />
        <PDComponent />
        <ContactComponent />
        <HireusComponent />
        <WWEComponent />
        <FAQComponent />
        <TechnologyComponent />
        <ChatComponent />
        <ProductShowcaseComponent />
        <ConsultComponent />
        <TestimonialComponent />
        <ComapnyComponent />
        <FooterOneComponent />
        <FooterComponent />
      </motion.div>
    </>
  );
}

export default HomePage;
